export default __webpack_public_path__ + "static/media/icon-arrow-dropdown-top.b2c485fe.svg";